// extracted by mini-css-extract-plugin
export default {"video":"Video_video__Q2Yns","video--mirrored":"Video_video--mirrored__ihMTs"};